<template>
	<div class="print-solicitacao" style="overflow-x: hidden">
		<div class="fl-cabecalho no-print" v-if="visualizar">
			<div class="row">
				<div class="col-xs-6">
					<i class="icon icon-cadastro_usuarios"></i>
					<h3>{{ _traducao('global', 'usuario').toUpperCase() }}</h3>
					<h4 @click="_exibeSub('ad')" style="cursor: pointer">
						{{ _traducao('menu', 'menuAdministracao').toUpperCase() }}
						{{ _traducao('menu', 'menuGeral').toUpperCase() }}
						<i class="fa fa-angle-down" aria-hidden="true"></i>
					</h4>
				</div>

				<div class="col-xs-6">
					<button
						@click="$emit('volta-lista')"
						class="btn btn-default pull-right btn-lg"
						:title="_traducao('global', 'voltar')"
					>
						<i class="icon-left" style="font-size: 18px" aria-hidden="true"></i>
					</button>
					<button
						class="btn btn-default pull-right btn-lg"
						:title="_traducao('global', 'imprimir')"
						style="margin-right: 20px"
						@click="_print()"
					>
						<i class="icon-imprimir" style="font-size: 18px"></i>
					</button>
				</div>
			</div>
		</div>
		<div class="row print">
			<flCabecalho widthimg="130" top="16" />
		</div>
		<div class="table-responsive" style="margin-top: 8px">
			<table class="table table-bordered table-condensed">
				<thead>
					<tr>
						<th colspan="5" style="background: #eee" class="text-center">
							{{ _traducao('global', 'fichaCadastralFuncional').toUpperCase() }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td colspan="2">
							<small>{{ _traducao('global', 'nomeCompleto') }}</small>
							<p>{{ form.nome | na }}</p>
						</td>
						<td
							colspan="2"
							v-if="
								_idCliente !== 41 ||
								_idCliente !== 9  ||
								_idCliente !== 43 ||
								_idCliente !== 36 ||
								_idCliente !== 38 ||
								_idCliente !== 30 ||
								_idCliente !== 50 ||
								_idCliente !== 58 ||
								_idCliente !== 60 ||
								_idCliente !== 62 ||
								_idCliente !== 65 ||
								_idCliente !== 47 ||
								_idCliente !== 74
							"
						>
							<small>{{ _traducao('menuAGnovoUsuario', 'menuAGanac') }}</small>
							<p>{{ form.codigo_anac | na }}</p>
						</td>
						<td>
							<span>
								<small>{{ _traducao('global', 'trigrama') }}</small>
								<p>{{ form.trigrama | na }}</p>
							</span>
						</td>
					</tr>

					<tr
						v-if="
							_idCliente == 41 ||
							_idCliente == 9 ||
							_idCliente == 43 ||
							_idCliente == 30 ||
							_idCliente == 36 ||
							_idCliente == 38 ||
							_idCliente == 50 ||
							_idCliente == 58 ||
							_idCliente == 60 ||
							_idCliente == 62 ||
							_idCliente == 65 ||
							_idCliente == 47 || 
							_idCliente == 74
						"
					>
						<td colspan="3">
							<small>{{ _traducao('global', 'endereco') }}</small>
							<p>{{ form.logradouro | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'numero') }}</small>
							<p>{{ form.numero | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'complemento') }}</small>
							<p>{{ form.complemento | na }}</p>
						</td>
					</tr>
					<tr
						v-if="
							_idCliente == 41 ||
							_idCliente == 9 ||
							_idCliente == 43 ||
							_idCliente == 36 ||
							_idCliente == 30 ||
							_idCliente == 38 ||
							_idCliente == 50 ||
							_idCliente == 58 ||
							_idCliente == 60 ||
							_idCliente == 62 ||
							_idCliente == 65 ||
							_idCliente == 47 ||
							_idCliente == 74
						"
					>
						<td>
							<small>{{ _traducao('global', 'bairro') }}</small>
							<p>{{ form.bairro | na }}</p>
						</td>
						<td colspan="2">
							<small>{{ _traducao('global', 'cep') }}</small>
							<p>{{ form.cep | na }}</p>
						</td>
						<td colspan="2">
							<small>{{ _traducao('global', 'cidade') }}</small>
							<p>{{ form.cidade | na }}</p>
						</td>
					</tr>
					<tr>
						<td>
							<small>{{ _traducao('menuAGnovoUsuario', 'menuAGcpf') }}</small>
							<p>{{ form.cpf | na }}</p>
						</td>
						<td>
							<small>CREA </small>
							<p>{{ form.crea | na }}</p>
						</td>
						<td v-if="exibeOutro">
							<small>{{ nomeOutroDocumento }}</small>
							<p>{{ form.outro | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'funcaoNaEmpresa') }}</small>
							<p>{{ cargo | na }}</p>
						</td>
					</tr>
					<tr
						v-if="
							_idCliente == 41 ||
							_idCliente == 9 ||
							_idCliente == 43 ||
							_idCliente == 36 ||
							_idCliente == 30 ||
							_idCliente == 38 ||
							_idCliente == 50 ||
							_idCliente == 58 ||
							_idCliente == 60 ||
							_idCliente !== 62 || 
							_idCliente == 47 ||
							_idCliente == 74
						"
					>
						<td>
							<small>{{ _traducao('global', 'funcaoComoTripulante') }}</small>
							<p>{{ cargo | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'tipoDeLicenca') }}</small>
							<p>{{ licenca.sigla | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'numeroLicenca') }}</small>
							<p>{{ funcao.numero_licenca | na }}</p>
						</td>
						<td colspan="2">
							<small>{{ _traducao('menuAGnovoUsuario', 'menuAGanac') }}</small>
							<p>{{ form.codigo_anac | na }}</p>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<small>{{ _traducao('global', 'email') }}</small>
							<p>{{ form.email | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('menuAGnovoUsuario', 'menuAGcel1') }}</small>
							<p>{{ form.celular | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('menuAGnovoUsuario', 'menuAGcel2') }}</small>
							<p>{{ form.celular2 | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'telefone') }}</small>
							<p>{{ form.telefone | na }}</p>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="table-responsive">
			<table class="table table-bordered table-condensed">
				<thead>
					<tr>
						<th colspan="4" style="background: #eee" class="text-center">
							{{ _traducao('menuAGnovoUsuario', 'menuAGacesso') }}
						</th>
					</tr>
				</thead>
				<tbody>
					<td>
						<small>{{ _traducao('menuAGnovoUsuario', 'menuAGsistema') }}</small>
						<p v-if="form.login !== ''">SIM</p>
						<p v-else>NÃO</p>
					</td>
					<td>
						<small>{{ _traducao('menuAGnovoUsuario', 'menuAGlogin') }}</small>
						<p>{{ form.login }}</p>
					</td>
					<td>
						<small>{{ _traducao('global', 'perfis') }}</small>
						<p>
							<span v-for="(p, idx) in form.perfis">
								<span v-if="idx < form.perfis.length - 1">
									{{ p.descricao }}/
								</span>

								<span v-else>
									{{ p.descricao }}
								</span>
							</span>
						</p>
					</td>
					<td>
						<small>ASSINATURA ICP?</small>
						<p v-if="form.certificado_icp == '1'">SIM</p>
						<p v-else>NÃO</p>
					</td>
				</tbody>
			</table>
		</div>
		<div
			class="table-responsive"
			v-if="
				_idCliente == 41 ||
				_idCliente == 9 ||
				_idCliente == 43 ||
				_idCliente == 36 ||
				_idCliente == 38 ||
				_idCliente == 30 ||
				_idCliente == 50 ||
				_idCliente == 58 ||
				_idCliente == 60 ||
				_idCliente == 62 ||
				_idCliente == 65 || 
				_idCliente == 47
			"
		>
			<table class="table table-bordered table-condensed">
				<thead>
					<tr>
						<th colspan="4" style="background: #eee" class="text-center">
							{{ _traducao('global', 'enderecoFuncional') }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<small>CEP</small>
							<p>{{ form.cep_funcional | na }}</p>
						</td>
						<td>
							<small>{{
								_traducao('menuAGnovoUsuario', 'menuAGlogradouro')
							}}</small>
							<p>{{ form.logradouro_funcional | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'numero') }}</small>
							<p>
								{{ form.numero_funcional | na }}
							</p>
						</td>
						<td>
							<small>{{
								_traducao('menuAGnovoUsuario', 'menuAGcomplemento')
							}}</small>
							<p>
								{{ form.complemento_funcional | na }}
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<small>{{
								_traducao('menuAGnovoUsuario', 'menuAGbairro')
							}}</small>
							<p>
								{{ form.bairro_funcional | na }}
							</p>
						</td>
						<td colspan="2">
							<small>{{
								_traducao('menuAGnovoUsuario', 'menuAGcidade')
							}}</small>
							<p>
								{{ form.cidade_funcional | na }}
							</p>
						</td>
						<td>
							<small>{{
								_traducao('menuAGnovoUsuario', 'menuAGestado')
							}}</small>
							<p>
								{{ form.estado_funcional | na }}
							</p>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div
			class="table-responsive"
			v-if="
				_idCliente == 41 ||
				_idCliente == 9 ||
				_idCliente == 43 ||
				_idCliente == 36 ||
				_idCliente == 30 ||
				_idCliente == 38 ||
				_idCliente == 50 ||
				_idCliente == 58 ||
				_idCliente == 60 ||
				_idCliente == 62 ||
				_idCliente == 65 ||
				_idCliente == 47 || 
				_idCliente == 74
			"
		>
			<table class="table table-bordered table-condensed">
				<thead>
					<tr>
						<th colspan="4" style="background: #eee" class="text-center">
							{{ _traducao('global', 'tipoDeUsuario') }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<small>{{ _traducao('cadAeronave', 'tipo') }}:</small>
							<p v-if="this.tipo == 'O'">
								{{ _traducao('global', 'operacional') }}
							</p>
							<p v-else>{{ _traducao('global', 'solicitante') }}</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'orgao') }}</small>
							<p>
								{{ exibeNome(form.id_orgao, orgaos) | na }}
							</p>
						</td>
						<td>
							<small>{{
								_traducao('menuAGnovoUsuario', 'menuAGmatricula')
							}}</small>
							<p>
								{{ form.masp | na }}
							</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'nomeTratamento') }}</small>
							<p>
								{{ form.nome_guerra | na }}
							</p>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<small>{{ _traducao('menuAGnovoUsuario', 'menuAGposto') }}</small>
							<p>
								{{ exibeNome(form.id_posto_graduacao, postos) | na }}
							</p>
						</td>
						<td colspan="2">
							<small>{{ _traducao('global', 'cargo') }}</small>
							<p>
								{{ cargo | na }}
							</p>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div
			class="table-responsive"
			v-if="
				_idCliente == 41 ||
				_idCliente == 9 ||
				_idCliente == 43 ||
				_idCliente == 36 ||
				_idCliente == 30 ||
				_idCliente == 38 ||
				_idCliente == 50 ||
				_idCliente == 58 ||
				_idCliente == 60 ||
				_idCliente == 62 ||
				_idCliente == 65 || 
				_idCliente == 47 
			"
		>
			<table class="table table-bordered table-condensed">
				<thead>
					<tr>
						<th colspan="4" style="background: #eee" class="text-center">
							{{ _traducao('global', 'baseContratualETransferencia') }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td colspan="2">
							<small>{{ _traducao('global', 'baseContratual') }}</small>
							<p v-if="form.base_contratual && form.base_contratual.length > 0">
								{{ exibeNome(form.base_contratual[0].id_base, bases) }}
							</p>
							<p v-else>N/A</p>
						</td>
						<td colspan="2">
							<small>{{ _traducao('global', 'data') }}</small>
							<p v-if="form.base_contratual && form.base_contratual.length > 0">
								{{
									_SQLDateToDate(form.base_contratual[0].data, 'DD/MM/YYYY')
										| na
								}}
							</p>
							<p v-else>N/A</p>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div
			class="table-responsive"
			v-if="
				_idCliente == 41 ||
				_idCliente == 9 ||
				_idCliente == 43 ||
				_idCliente == 36 ||
        _idCliente == 30 ||
				_idCliente == 38 ||
				_idCliente == 50 ||
				_idCliente == 58 ||
				_idCliente == 60 ||
				_idCliente == 62 ||
				_idCliente == 65 || 
				_idCliente == 47 
			"
		>
			<table class="table table-bordered table-condensed">
				<thead>
					<tr>
						<th colspan="4" style="background: #eee" class="text-center">
							{{ _traducao('global', 'funcoes') }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<small>{{ _traducao('global', 'funcao') }}</small>
							<p v-if="form.funcao && form.funcao.length > 0">
								{{ exibeNome(form.funcao[0].id_funcao, funcoes) }}
							</p>
							<p v-else>N/A</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'fabricante') }}</small>
							<p v-if="form.funcao && form.funcao.length > 0">
								{{ exibeNome(form.funcao[0].id_fabricante, fabricantes) }}
							</p>
							<p v-else>N/A</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'modelo') }}</small>
							<p v-if="form.funcao && form.funcao.length > 0">
								{{ exibeNome(form.funcao[0].id_modelo, modelos) }}
							</p>
							<p v-else>N/A</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'data') }}</small>
							<p v-if="form.funcao && form.funcao.length > 0">
								{{ _SQLDateToDate(form.funcao[0].data, 'DD/MM/YYYY') }}
							</p>
							<p v-else>N/A</p>
						</td>
					</tr>
					<tr>
						<td>
							<small>{{ _traducao('global', 'licenca') }}</small>
							<p v-if="form.funcao && form.funcao.length> 0">
								{{ exibeNome(form.funcao[0].id_licenca, licencas) }}
							</p>
							<p v-else>N/A</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'numeroLicenca') }}</small>
							<p v-if="form.funcao && form.funcao.length > 0">
								{{ form.funcao[0].numero_licenca }}
							</p>
							<p v-else>N/A</p>
						</td>
						<td colspan="2">
							<small>{{ _traducao('global', 'habilitacao') }}</small>
							<p v-if="form.funcao && form.funcao.length > 0">
								{{ exibeNome(form.funcao[0].id_habilitacao, habilitacoes) }}
							</p>
							<p v-else>N/A</p>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div
			class="table-responsive"
			v-if="
				_idCliente == 41 ||
				_idCliente == 9 ||
				_idCliente == 43 ||
				_idCliente == 30 ||
				_idCliente == 36 ||
				_idCliente == 38 ||
				_idCliente == 50 ||
				_idCliente == 58 ||
				_idCliente == 60 ||
				_idCliente == 62 ||
				_idCliente == 65 || 
				_idCliente == 47 
			"
		>
			<table class="table table-bordered table-condensed">
				<thead>
					<tr>
						<th colspan="4" style="background: #eee" class="text-center">
							{{ _traducao('global', 'emergencia') }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<small>{{ _traducao('menuAGcadAluno', 'tipoSanguineo') }}</small>
							<p>{{ form.tipo_sanguineo | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('menuAGcadAluno', 'fatorRH') }}</small>
							<p>{{ form.fator_rh | na }}</p>
						</td>
						<td colspan="2">
							<small>{{ _traducao('global', 'alergia') }}</small>
							<p>{{ form.alergia | na }}</p>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div
			class="table-responsive"
			v-if="
				_idCliente == 41 ||
				_idCliente == 9 ||
				_idCliente == 43 ||
				_idCliente == 30 ||
				_idCliente == 36 ||
				_idCliente == 38 ||
				_idCliente == 50 ||
				_idCliente == 58 ||
				_idCliente == 60 ||
				_idCliente == 62 ||
				_idCliente == 65 || 
				_idCliente == 47
			"
		>
			<table class="table table-bordered table-condensed">
				<thead>
					<tr>
						<th colspan="4" style="background: #eee" class="text-center">
							{{ _traducao('global', 'contatoDeEmergencia') }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<small>{{ _traducao('global', 'nome') }}</small>
							<p>{{ form.nome_emergencia | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'grauDeRelacionamento') }}</small>
							<p>{{ form.grau_emergencia | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'telefone') }}</small>
							<p>{{ form.telefone_emergencia | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'telefone') }}</small>
							<p>{{ form.celular_emergencia | na }}</p>
						</td>
					</tr>
					<tr>
						<td>
							<small>CEP</small>
							<p>{{ form.cep_emergencia | na }}</p>
						</td>
						<td colspan="2">
							<small>{{
								_traducao('menuAGnovoUsuario', 'menuAGlogradouro')
							}}</small>
							<p>{{ form.logradouro_emergencia | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'numero') }}</small>
							<p>{{ form.numero_emergencia | na }}</p>
						</td>
					</tr>
					<tr>
						<td>
							<small>{{ _traducao('global', 'complemento') }}</small>
							<p>{{ form.complemento_emergencia | na }}</p>
						</td>
						<td>
							<small>{{
								_traducao('menuAGnovoUsuario', 'menuAGbairro')
							}}</small>
							<p>
								{{ form.bairro_emergencia | na }}
							</p>
						</td>
						<td>
							<small>{{
								_traducao('menuAGnovoUsuario', 'menuAGcidade')
							}}</small>
							<p>
								{{ form.cidade_emergencia | na }}
							</p>
						</td>
						<td>
							<small>{{
								_traducao('menuAGnovoUsuario', 'menuAGestado')
							}}</small>
							<p>
								{{ form.estado_emergencia | na }}
							</p>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div
			class="table-responsive"
			v-if="
				_idCliente == 41 ||
				_idCliente == 9 ||
				_idCliente == 43 ||
				_idCliente == 30 ||
				_idCliente == 36 ||
				_idCliente == 38 ||
				_idCliente == 50 ||
				_idCliente == 58 ||
				_idCliente == 60 ||
				_idCliente == 62 ||
				_idCliente == 65 || 
				_idCliente == 47 
			"
		>
			<table class="table table-bordered table-condensed">
				<thead>
					<tr>
						<th colspan="4" style="background: #eee" class="text-center">
							{{ _traducao('global', 'vencimentos').toUpperCase() }}
						</th>
					</tr>
					<tr v-if="form.vencimentos && form.vencimentos.length > 0">
						<th style="background: #eee">
							{{ _traducao('global', 'tipo').toUpperCase() }}
						</th>
						<th style="background: #eee" class="text-center">
							{{ _traducao('global', 'emissao').toUpperCase() }}
						</th>
						<th style="background: #eee" class="text-center">
							{{ _traducao('global', 'validade').toUpperCase() }}
						</th>
						<th style="background: #eee" class="text-right">
							{{ _traducao('global', 'diasRestantes').toUpperCase() }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in form.vencimentos" :key="index">
						<td>{{ item.tipo | na }}</td>
						<td class="text-center">{{ item.emissao | data }}</td>
						<td class="text-center">{{ item.validade | data }}</td>
						<td class="text-right">{{ item.dias_restantes | na }}</td>
					</tr>
					<tr v-if="form.vencimentos && form.vencimentos.length <= 0">
						<td colspan="4" class="text-center">
							{{ _traducao('global', 'usuarioSemLicenca') }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<flGeradoPor />
	</div>
</template>
<script>
import flEndereco from '../../../../../components/endereco/main.vue'
import flDadosAdicionais from './dados-adicionais.vue'
import cabecalhoUsuario from '../cabecalho/main.vue'
export default {
	components: {cabecalhoUsuario, flDadosAdicionais, flEndereco},
	props: {
		cargos: Array,
		orgaos: {type: Array, default: () => []},
		visualizar: {
			type: Boolean,
			default: false
		},
		bases: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		funcoes: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		postos: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		fabricantes: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		habilitacoes: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		licencas: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		modelos: {
			default() {
				return []
			},
			type: Array,
			required: true
		}
	},
	data() {
		return {
			token: null,
			form: {},
			tipo: '',
			exibeOutro: false,
			nomeOutroDocumento: '',
		}
	},
	computed: {
		cargo() {
			const cargo = this.cargos.find((val) => val.id == this.form.cargo)
			return !cargo ? '' : cargo.descricao
		},
		funcao() {
			if (Array.isArray(this.form.funcao) && this.form.funcao.length > 0) {
				return this.form.funcao[0]
			}
			return {}
		},
		licenca() {
			const licenca = this.licencas.find(
				(val) => val.id == this.funcao.id_licenca
			)
			return !licenca ? {} : licenca
		}
	},
	created() {
		this.parametros()
	},
	methods: {
		carregaForm(form) {
			this._httpGet(
				'/Usuario/editar/' + form.id,
				(retorno) => {
					window.bus.$emit('load-out')
					if (retorno._request && retorno._status) {
						this.form = retorno.usuario
						this.form.perfis = retorno.perfis
						if (this.form.perfis.length == 1) {
							if (this.form.perfis[0].id == 21) {
								this.tipo = 'S'
							} else {
								this.tipo = 'O'
							}
						} else {
							this.tipo = 'O'
						}
					}
				},
				this.token
			)
		},
		exibeNome(id_orgao, lista) {
			const org = lista.find((orgao) => orgao.id === id_orgao)
			if (org) {
				return org.descricao
			} else {
				return null
			}
		},
		parametros() {
			this._getParametro(3).then((valor) => {
				if (Number(valor)) {
					this.exibeOutro = Number(valor)
					this._getParametro(4).then((val) => {
						if (typeof val === 'string') {
							this.nomeOutroDocumento = val.capitalizeFirst()
						}
					})
				}
			})
		}
	}
}
</script>
<style scoped>
small {
	font-weight: bolder;
}
</style>